<template>
  <span class="countdown-timer">
    <span v-if="days > 0" class="time-box days" :style="boxStyle">{{ days }}d</span>
    <span v-if="days > 0" class="separator">:</span>
    <span class="time-box" :style="boxStyle">{{ paddedHours }}h</span>
    <span class="separator">:</span>
    <span class="time-box" :style="boxStyle">{{ paddedMinutes }}m</span>
    <span class="separator">:</span>
    <span class="time-box" :style="boxStyle">{{ paddedSeconds }}s</span>
  </span>
</template>

<script>
export default {
  props: {
    endTime: {
      type: String,
      required: true
    },
    backgroundColor: {
      type: String,
      default: '#619b96'
    }
  },
  data() {
    return {
      timeRemaining: null,
      timer: null
    }
  },
  computed: {
    boxStyle() {
      return {
        backgroundColor: this.backgroundColor
      };
    },
    days() {
      return Math.floor(this.timeRemaining / 86400);
    },
    paddedHours() {
      const hours = Math.floor((this.timeRemaining % 86400) / 3600);
      return hours.toString().padStart(2, '0');
    },
    paddedMinutes() {
      const minutes = Math.floor((this.timeRemaining % 3600) / 60);
      return minutes.toString().padStart(2, '0');
    },
    paddedSeconds() {
      const seconds = this.timeRemaining % 60;
      return seconds.toString().padStart(2, '0');
    }
  },
  mounted() {
    this.startTimer();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    startTimer() {
      this.calculateTimeRemaining();
      this.timer = setInterval(this.calculateTimeRemaining, 1000);
    },
    calculateTimeRemaining() {
      const now = new Date().getTime();
      const end = new Date(this.endTime).getTime();
      const difference = Math.floor((end - now) / 1000);

      if (difference <= 0) {
        clearInterval(this.timer);
        this.timeRemaining = null;
      } else {
        this.timeRemaining = difference;
      }
    }
  }
}
</script>
